import React from 'react';
import PropTypes from 'proptypes';
import classnames from 'classnames';

import styles from './button-component.styles.scss';


export const ButtonComponent = (_props) => {
  const { className, ...props } = _props;
  const classname = classnames(
    styles.Button,
    styles[`Button--${props.role}`],
    className);

  return (
    <button className={classname} {...props} />
  );
}

ButtonComponent.propTypes = {
  role: PropTypes.oneOf(['primary', 'secondary', 'error']),
}

ButtonComponent.defaultProps = {
  role: 'primary',
}



// WEBPACK FOOTER //
// ./src/components/button/button/button.component.jsx